import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { HR } from 'foundations-components/transitional/components/HR';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SectionHeader = ({
  content = ''
}) => /*#__PURE__*/_jsxs(View, {
  paddingBlockStart: "600",
  paddingBlockEnd: "300",
  paddingInline: "600",
  children: [/*#__PURE__*/_jsx(Text, {
    as: "h7",
    children: content
  }), /*#__PURE__*/_jsx(HR, {})]
});
export default SectionHeader;